class GorgiasChat extends HTMLElement {
  constructor() {
    super();
    this.chatWrapper = this.querySelector('#chat-wrapper');
  }

  connectedCallback() {
    let popupButton = this.chatWrapper.querySelector('#chat-open-icon');
    let popupSvg = popupButton.querySelector('svg path:nth-child(3)');
    let popupCloseButton = this.chatWrapper.querySelector('#chat-close-icon');
    let chatButton = this.chatWrapper.querySelector('#chat-open-link');
    let popupCloseButtonMobileContainer = this.chatWrapper.querySelector('#chat-button-mobile');
    let popupCloseButtonMobile = this.chatWrapper.querySelector('#chat-close-icon-mobile');
    let ChatInterstitial = this.chatWrapper.querySelector('#chat-interstitial');

    popupButton.addEventListener('click', () => {
      this.loadGorgiasScript().then((script) => {
        let initGorgiasChatPromise = window.GorgiasChat
          ? window.GorgiasChat.init()
          : new Promise((resolve) => {
              window.addEventListener('gorgias-widget-loaded', () => {
                resolve();
              });
            });

        initGorgiasChatPromise.then(async () => {
          let chatElem = document.getElementById('gorgias-chat-container');

          window.GorgiasChat.on('widget:opened', (data) => {
            this.hide([popupButton]);
            this.show([popupCloseButton]);
          });

          window.GorgiasChat.on('widget:closed', (data) => {
            this.show([popupButton]);
            this.hide([popupCloseButton, popupCloseButtonMobileContainer]);
          });

          window.GorgiasChat.on('unreadCount', (data) => {
            let unread = data.unseenCount;
            if (unread === 0) {
              this.hide([popupSvg]);
            } else if (unread === 1) {
              this.show([popupSvg]);
            } else {
              window.GorgiasChat.open();
            }
          });

          if (this.getCookie('chat-opened')) {
            window.GorgiasChat.open();
            this.hide([popupButton]);
            this.show([popupCloseButton, popupCloseButtonMobileContainer]);
          } else {
            chatElem.classList.add('hidden');
            this.toggleVisibility([popupButton, popupCloseButton, popupCloseButtonMobileContainer, ChatInterstitial]);
            document.getElementById('chat-open-link')?.addEventListener('click', (ev) => {
              ev.preventDefault();
              chatElem.classList.remove('hidden');
              window.GorgiasChat.open();
              this.hide([ChatInterstitial]);
            });
          }
        });
      });
    });

    popupCloseButton.addEventListener('click', () => {
      if (window.GorgiasChat.isOpen()) {
        window.GorgiasChat.close();
        this.show([popupButton]);
        this.hide([popupCloseButton, popupCloseButtonMobileContainer]);
      } else {
        this.toggleVisibility([popupButton, popupCloseButton, popupCloseButtonMobileContainer, ChatInterstitial]);
      }
    });

    popupCloseButtonMobile.addEventListener('click', () => {
      this.toggleVisibility([popupButton, popupCloseButton, popupCloseButtonMobileContainer, ChatInterstitial]);
    });

    chatButton.addEventListener('click', () => {
      console.log('chatButtonClick');
      this.hide([ChatInterstitial]);
      this.setCookie('chat-opened', '1', { path: '/' });
      window.GorgiasChat.open();
    });

    if (!this.__gorgiasChatGlobalListenerAdded) {
      const chatOpenLinks = document.querySelectorAll('.gorgias-chat-open-link');

      chatOpenLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();

          const chatInstance = document.querySelector('gorgias-chat');
          if (!chatInstance) return;

          chatInstance.loadGorgiasScript().then(() => {
            const initGorgiasChatPromise = window.GorgiasChat
              ? window.GorgiasChat.init()
              : new Promise((resolve) => {
                  window.addEventListener('gorgias-widget-loaded', resolve);
                });

            initGorgiasChatPromise.then(() => {
              const chatElem = document.getElementById('gorgias-chat-container');
              const popupButton = chatInstance.querySelector('#chat-open-icon');
              const popupCloseButton = chatInstance.querySelector('#chat-close-icon');
              const popupCloseButtonMobileContainer = chatInstance.querySelector('#chat-button-mobile');
              const interstitial = chatInstance.querySelector('#chat-interstitial');

              if (chatElem) chatElem.classList.remove('hidden');
              if (interstitial) chatInstance.hide([interstitial]);

              chatInstance.setCookie('chat-opened', '1', { path: '/' });
              window.GorgiasChat.open();
              chatInstance.hide([popupButton]);
              chatInstance.show([popupCloseButton, popupCloseButtonMobileContainer]);
            });
          });
        });
      });

      this.__gorgiasChatGlobalListenerAdded = true;
    }
  }

  loadGorgiasScript() {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.setAttribute('id', 'gorgias-chat-widget-install-v3');
      script.async = true;
      script.src = 'https://config.gorgias.chat/bundle-loader/01HM6Q688YPVQCRWZRG9512CKQ';
      script.onload = () => resolve(script);
      script.onerror = () => reject(new Error('Failed to load Gorgias script.'));

      document.head.appendChild(script);
    });
  }

  toggleVisibility(elements) {
    elements = Array.isArray(elements) ? elements : [elements];
    elements.forEach(function (element) {
      element.classList.toggle('hidden');
      element.classList.toggle('block');
    });
  }
  hide(elements) {
    elements = Array.isArray(elements) ? elements : [elements];
    elements.forEach(function (element) {
      element.classList.add('hidden');
      element.classList.remove('block');
    });
  }

  show(elements) {
    elements = Array.isArray(elements) ? elements : [elements];
    elements.forEach(function (element) {
      element.classList.remove('hidden');
      element.classList.add('block');
    });
  }

  //setCookie not used at present
  setCookie(name, value, options = {}) {
    options = {
      path: '/',
      value: '1',
    };

    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }

    let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

    for (let optionKey in options) {
      updatedCookie += '; ' + optionKey;
      let optionValue = options[optionKey];
      if (optionValue !== true) {
        updatedCookie += '=' + optionValue;
      }
    }

    document.cookie = updatedCookie;
  }

  //getCookie not used at present
  getCookie(name) {
    let matches = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[]\\\/+^])/g, '\\$1') + '=([^;]*)'),
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }
}

customElements.define('gorgias-chat', GorgiasChat);
